// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {get} from 'lodash';

// HA Artifactory Imports
import {Checkbox} from '@homeaway/react-form-components';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {SVGIcon} from '@homeaway/react-svg';
import {Link} from '@homeaway/react-localization-components';

// Relative import
import poActions from '../../actions/purchaseOrder';
import appActions from '../../actions/actions';
import userInfoActions from '../../actions/userInfo';
import AlertBox from '../Alert/Alert';
import downloadIcon from '../../images/download-icon';
import PDFComponent from './PDFComponent';
import SubHead from '../SubHead/SubHead';
import {PROPERTY_OFFER_TYPE} from '../../utils/constants';
import {isPPM, isUsSite} from '../../utils/validate';
import {isNetNewIPM,isDSABrandSite} from '../../utils/validate';
import './styles.less';

function mapStateToProps(state) {
    return {
        publicUuid: state.app.publicUuid,
        translations: state.app.translations,
        siteName: state.system.siteName,
        fileURL: state.purchaseOrder.fileURL,
        file: state.purchaseOrder.file,
        errorKeyPO: state.purchaseOrder.errorKeyPO,
        errorKeyApproval: state.purchaseOrder.errorKeyApproval,
        accountUuid: get(state, 'app.accountUuid', ''),
        purchaseOrder: get(state, 'purchaseOrder', {}),
        isSaveModalOpen: get(state, 'app.isSaveModalOpen', false),
        poAgree: get(state, 'purchaseOrder.agree', false),
        softwareName: get(state, 'userInfoDetails.userInfoMetadata.ipm.resellerName', ''),
        softwareUserId: get(state, 'userInfoDetails.userInfoMetadata.ipm.externalId', ''),
        dyff: get(state, 'app.dyff', {}),
        advertiserBusinessModel: get(state, 'userInfoDetails.userInfoMetadata.businessModel', null),
        userType: get(state, 'app.userType', 'IPM')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        userInfoActions: bindActionCreators(userInfoActions, dispatch),
        poActions: bindActionCreators(poActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class PurchaseOrder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            agree: false,
            fileURL: ''
        };
        this.toggleAgree = this.toggleAgree.bind(this);
        this.downloadDocs = this.downloadDocs.bind(this);
        this.downloadPdfLink = this.downloadPdfLink.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleScrollToBottom = this.handleScrollToBottom.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.handleSaveAndFinishOnClick = this.handleSaveAndFinishOnClick.bind(this);
        this.prePopulateLocalState = this.prePopulateLocalState.bind(this);
        this.handleSaveModalClose = this.handleSaveModalClose.bind(this);
        this.downloadActionForIE11 = this.downloadActionForIE11.bind(this);
    }

    componentWillMount() {
        this.props.appActions.enableLoadOverLay(true);
        this.props.poActions.getPurchaseOrder();
        this.props.userInfoActions.getUserInfo();
        this.prePopulateLocalState();
        if (isPPM(this.props.userType)) {
            this.props.appActions.saveComponentPath('PURCHASE_ORDER');
        }
    }

    componentDidMount() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Purchase Order Page');
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.poAgree) {
            this.setState({
                agree: this.props.poAgree
            });
        }
    }

    handleScrollToBottom() {
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: 'Purchase Order scrolled to bottom',
            eventaction: 'Purchase Order scrolled to bottom',
        }, {});
    }

    downloadDocs() {
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Download documents'
        }, {});
    }

    downloadActionForIE11() {
        this.downloadDocs();
        window.navigator.msSaveOrOpenBlob(this.props.file, 'doc.pdf');
    }

    downloadPdfLink() {
        const {translations, fileURL} = this.props;

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            return (<Link onClick={this.downloadActionForIE11}>{translations['ipmob.pola.download.docs']}</Link>);
        }

        let fileName = translations['ipmob.pola.download.file.name'];

        if ((this.props.siteName === 'homeaway_au' || this.props.siteName === 'homeaway_nz') && this.props.dyff?.USE_V4_PURCHASE_ORDERS) {
            fileName = translations['ipmob.pola.download.file.name.v4'];
        }

        return (<Link href={fileURL} onClick={this.downloadDocs} download={fileName}>{translations['ipmob.pola.download.docs']}</Link>);
    }

    toggleAgree() {
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: 'Agreed Purchase Order',
            eventaction: `Agreed Purchase Order: ${!this.state.agree}`,
            highfrequency: 'true'
        }, {});
        this.setState({
            agree: !this.state.agree
        });
    }

    getCommercialOfferType() {
        let commercialOfferType;

        if (!isUsSite(this.props.siteName)) {
            commercialOfferType = PROPERTY_OFFER_TYPE.commercialOfferType;
        } else {
            commercialOfferType = PROPERTY_OFFER_TYPE.defaultOfferType;
        }

        return commercialOfferType;
    }

    handleSubmit() {
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue'
        }, {});
        this.props.appActions.enableLoadOverLay(true);
        const commercialOfferType = this.getCommercialOfferType();
        const currentBusinessModel = this.props.advertiserBusinessModel;
        this.props.poActions.recordApproval(commercialOfferType, currentBusinessModel, this.props.accountUuid);
    }

    handleAlertDismiss() {
        this.props.poActions.getPurchaseOrderError('');
        this.props.poActions.recordApprovalError('');
    }

    handleSaveAndFinishOnClick() {
        const stateData = {...this.props.purchaseOrder};
        stateData.agree = this.state.agree;
        delete stateData.errorKeyPO;
        delete stateData.errorKeyApproval;
        delete stateData.fileURL;
        this.props.appActions.saveComponentState('purchaseOrder', stateData);
        this.props.appActions.showSaveAndFinishModal(true);
    }

    prePopulateLocalState() {
        this.props.poActions.prePopulateLocalState(this.props.publicUuid);
    }

    handleSaveModalClose() {
        this.props.appActions.showSaveAndFinishModal(false);
    }

    determineAgreeLabel() {
        if (isNetNewIPM(this.props.userType) && isDSABrandSite(this.props.siteName)) {
            return this.props.translations["ipmob.pola.agree.dsa.desc"];
        }
        return this.props.translations["ipmob.pola.agree.desc"];

    }

    render() {
        let {translations, errorKeyPO, errorKeyApproval, fileURL, isSaveModalOpen} = this.props;
        let error;
        if (errorKeyPO) {
            error = errorKeyPO;
        } else if (errorKeyApproval) {
            error = errorKeyApproval;
        }

        return (
            <div className="pola-pg-container">
                <div className="pola-wrapper">
                    <SubHead
                        translations={translations}
                        handleSaveAndFinishOnClick={this.handleSaveAndFinishOnClick}
                        isSaveModalOpen={isSaveModalOpen}
                        handleSaveModalClose={this.handleSaveModalClose}
                    />
                    {error ? <div className="alert-panel">
                        <AlertBox
                            messageKey={error}
                            translations={translations}
                            handleAlertDismiss={this.handleAlertDismiss}
                            size={'sm'}
                        />
                    </div> : null}
                    <h2 className="pola-heading"> {translations['ipmob.pola.heading']} </h2>
                    <div className="pola-heading-desc"> {translations['ipmob.pola.desc']} </div>
                    <div className="pdf-wrapper">
                        {
                            (!errorKeyPO && fileURL)
                                ? <PDFComponent id="poFile" file={fileURL} handleScrollToBottom={this.handleScrollToBottom}/>
                                : null
                        }
                    </div>
                    <div className="pola-desc">
                        <Checkbox name={translations['ipmob.pola.agree.desc']}
                            label={this.determineAgreeLabel()}
                            checked={this.state.agree}
                            onChange={this.toggleAgree}
                            size="sm"
                        />
                        <div className="download-documents">
                            <SVGIcon className="po-icon" markup={downloadIcon}/>
                            {this.downloadPdfLink()}
                        </div>
                    </div>
                    <div className="pola-footer-wrapper">
                        <div className="pola-footer">
                            <ButtonPrimary className="pola-continue-button" label={translations['ipmob.continue']} type="submit" disabled = {!!(errorKeyPO || !this.state.agree)} onClick={this.handleSubmit}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
